/**
 * Videodan belirtilen saniyedeki frame'i JPEG blob olarak döndürür.
 * Sadece video dosyalarında çalışır; diğer türlerde null döner.
 */
export function getVideoThumbnailAtSecond(file: File, timeInSeconds: number): Promise<Blob | null> {
  const isVideo = file.type.startsWith('video/');
  if (!isVideo) return Promise.resolve(null);

  return new Promise((resolve) => {
    const url = URL.createObjectURL(file);
    const video = document.createElement('video');
    video.muted = true;
    video.preload = 'metadata';
    video.playsInline = true;
    video.crossOrigin = 'anonymous';
    video.src = url;

    const cleanup = () => {
      video.src = '';
      URL.revokeObjectURL(url);
    };

    video.onerror = () => {
      cleanup();
      resolve(null);
    };

    video.onloadeddata = () => {
      const targetTime = Math.min(Math.max(0, timeInSeconds), video.duration);
      video.currentTime = targetTime;
    };

    video.onseeked = () => {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          cleanup();
          resolve(null);
          return;
        }
        ctx.drawImage(video, 0, 0);
        canvas.toBlob(
          (blob) => {
            cleanup();
            resolve(blob);
          },
          'image/jpeg',
          0.85
        );
      } catch {
        cleanup();
        resolve(null);
      }
    };

    video.load();
  });
}
